import React, { useEffect, useState } from 'react';
import { Select, Tooltip, message } from 'antd';
import api from '../utils/api';

let presetCache = null;
let presetRequest = null;
const loadPresets = () => {
  if (presetCache) return Promise.resolve(presetCache);
  if (!presetRequest) presetRequest = api.get('/api/accounting/posting-presets').then(response => {
    presetCache = response.data.data || []; return presetCache;
  }).finally(() => { presetRequest = null; });
  return presetRequest;
};

export default function DocumentPresetQuickSelect({ documentType, documentId, value, accountingStatus, onChanged }) {
  const [presets, setPresets] = useState(presetCache || []); const [selected, setSelected] = useState(value || null); const [saving, setSaving] = useState(false);
  useEffect(() => { setSelected(value || null); }, [value]);
  useEffect(() => { loadPresets().then(setPresets).catch(() => message.error('โหลด Preset ไม่สำเร็จ')); }, []);
  const change = async next => {
    setSaving(true);
    try {
      await api.put(`/api/accounting/documents/${documentType}/${documentId}/preset`, { preset_id: next || null });
      setSelected(next || null); onChanged?.(next || null); message.success('กำหนดประเภทธุรกิจแล้ว');
    } catch (error) { message.error(error.response?.data?.message || 'กำหนด Preset ไม่สำเร็จ'); }
    finally { setSaving(false); }
  };
  const disabled = accountingStatus === 'posted';
  return <Tooltip title={disabled ? 'เอกสารลงบัญชีแล้ว ไม่สามารถเปลี่ยน Preset' : 'ใช้กำหนดผังบัญชีสำหรับ One Click'}>
    <Select size="small" allowClear showSearch optionFilterProp="label" placeholder="เลือกธุรกิจ" loading={saving}
      disabled={disabled} value={selected} onChange={change} style={{ width: 170 }}
      options={presets.map(preset => ({ value: Number(preset.id), label: preset.name }))} />
  </Tooltip>;
}
